<template>
  <el-select
    v-model="valueBackup"
    filterable
    :remote="true"
    :remote-method="search"
    :clearable="clearable"
    :multiple="multiple"
    @change="handleChange"
    :placeholder="placeholder"
    :size="size"
  >
    <el-option
      v-for="item of listBackup"
      :key="item.id"
      :label="item.course_name"
      :value="item.id"
      class="student-list-item"
    >
      <v-avatar :value="item.teacher_avatar" :size="90"/>
      <div class="student-nickname-box">
        <div v-html="getKeywordHtml('ID', item.id)" class="item"></div>
        <div v-html="getKeywordHtml('课程', item.course_name)" class="item"></div>
        <div v-html="getKeywordHtml('老师', item.teacher_names)" class="item"></div>
        <div v-html="getKeywordHtml('时间', item.course_time)" class="item"></div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
  import { index } from '@/api/course';

  export default {
    props: {
      value: [Number, Array],
      storeId: [Number, String],
      size: {
        type: String,
        default: 'medium',
      },
      placeholder: {
        type: String,
        default: '输入课程 ID 进行搜索',
      },
      list: {
        type: Array,
        default: () => [],
      },
      multiple: Boolean,
      clearable: Boolean,
    },
    data: () => ({
      valueBackup: [],
      listBackup: [],
    }),
    watch: {
      value(value) {
        if (this.multiple) {
          if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
        } else {
          if (value !== this.valueBackup) this.valueBackup = +value || '';
        }
      },
      valueBackup(valueBackup) {
        if (this.multiple) {
          if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
        } else {
          if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
        }
      },
      list(value) {
        this.listBackup = value;
      },
    },
    methods: {
      getKeywordHtml(label, words) {
        words = `${words}`.replace(
          RegExp(this.keyword, 'i'),
          (keyword) => `<span class='primary-color'>${keyword}</span>`,
        );
        return `${label}：<b>${words}</b>`;
      },
      async search(course_id) {
        course_id = +course_id;
        if (!course_id) return;
        const { isError, data } = await index({ course_id });
        if (!isError) this.listBackup = data || [];
      },
      handleChange(valueBackup) {
        this.$emit('change', valueBackup);
      },
    },
    beforeMount() {
      if (this.multiple) {
        this.valueBackup = this.value || [];
      } else {
        this.valueBackup = +this.value || '';
      }

      if (this.list.length) return this.listBackup = this.list;
    },
  };
</script>


<style scoped>
.student-list-item {
  display: flex;
  align-items: center;
  height: 120px;
}

.student-nickname-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
}

.item {
  height: 25px;
  line-height: 25px;
}
</style>
